


















import { Component, Prop, Vue } from "vue-property-decorator";
import { IMenuRoute } from "@/models/routes";
import { ICrumb } from "@/components/app-base/UBreadcrumbs.vue";

@Component
export default class AdminUpmindClientProducts extends Vue {
  // Props

  @Prop({ default: () => () => [] })
  public routes!: () => IMenuRoute[];

  // Data

  public breadcrumbs: ICrumb[] = [
    {
      label: this.$t("_.my_upmind"),
      route: {
        to: {
          name: "admin__upmindAccount"
        }
      }
    }
  ];
}
